interface Models {
  user: { id: string }
  planbook: { id: string }
}

export default function (_payload, models: Models, verb = "edited") {
  let user = models.user || {}
  return {
    actor: `user-${user.id}`,
    verb: verb,
    object: `planbook-${models.planbook.id}`,
    to: [`planbook-edits:planbook-${models.planbook.id}`],
  }
}
